import { render, staticRenderFns } from "./productmanage.vue?vue&type=template&id=6de0a57e&scoped=true"
import script from "./productmanage.vue?vue&type=script&lang=js"
export * from "./productmanage.vue?vue&type=script&lang=js"
import style0 from "./productmanage.vue?vue&type=style&index=0&id=6de0a57e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de0a57e",
  null
  
)

export default component.exports